<template>
  <div class="navigation-wrap">
    <div class="thumb-list">
      <div v-for="(item, i) in data" :key="i" class="thumb-item" :class="{active:index===i}" @click="goPage(i)">
        <img :src="item.url" crossorigin="anonymous" class="thumb-img" alt>
        <div v-if="item.isCover" class="cover-tag">封面</div>
        <div class="clip-btn" @click.stop="crop(item)">裁剪</div>
        <div class="del-btn" @click.stop="del(item)">删除</div>
        <div class="cover-btn" @click.stop="setCover(item)">设为封面</div>
        <div class="res-cover-btn" @click.stop="setResCover(item)">设为资源封面</div>
      </div>
    </div>
  </div>
</template>

<script>
import { deletePdfImg, setCoverPicture } from '@/api/common'

export default {
  props: {
    id: {
      type: Number,
      default: undefined
    },
    nodeId: {
      type: Number,
      default: undefined
    },
    resNode: { // 资源节点
      type: Number,
      default: undefined
    },
    contentId: { // 资源id
      type: Number,
      default: undefined
    },
    data: {
      type: Array,
      default: undefined
    },
    index: {
      type: Number,
      default: 0
    }
  },
  methods: {
    goPage(index) {
      this.$emit('goPage', index, this.data[index])
    },
    crop(data) {
      this.$emit('crop', data)
    },
    del(item) {
      this.$confirm('确定要删除这张图片吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deletePdfImg(item.id).then(response => {
          const { code, msg } = response
          if (code === 200) {
            this.$message.success('删除成功')
            this.$emit('setCoverSuccess')
          } else {
            this.$message.error(msg)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    setCover(item) {
      // 设为封面图
      const params = {
        nodeId: this.nodeId,
        contentId: this.id,
        url: item.url,
        type: 0
      }
      setCoverPicture(params).then(response => {
        const { code, msg } = response
        if (code === 200) {
          this.$message.success('设为封面图成功！')
          this.$emit('setCoverSuccess')
        } else {
          this.$message.error(msg)
        }
      })
    },
    setResCover(item) {
      // 设为资源封面图
      const params = {
        nodeId: this.resNode,
        contentId: this.contentId,
        url: item.url,
        type: 0
      }
      setCoverPicture(params).then(response => {
        const { code, msg } = response
        if (code === 200) {
          this.$message.success('设为资源封面图成功！')
          this.$emit('setCoverSuccess')
        } else {
          this.$message.error(msg)
        }
      })
    }
  }
}
</script>

<style scoped>
.navigation-wrap {
  position: absolute;
  top: 0;
  right: 0;
  width: 220px;
  height: 100%;
  overflow: hidden;
  background: #000;
  display: flex;
  flex-direction: column;
}

.thumb-list {
  position: absolute;
  top: 20px;
  right: 10px;
  bottom: 0;
  width: 200px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 5px;
}

.thumb-list::-webkit-scrollbar {
  width: 6px;
}

.thumb-list::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 3px;
}

.thumb-list::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 3px;
}

.thumb-list::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.5);
}

.thumb-list .thumb-item {
  width: 80%;
  margin: 0 auto;
  padding: 10px;
  border: 2px solid transparent;
  cursor: pointer;
  position: relative;
}

.thumb-list .thumb-item.active {
  border-color: #12aa9c;
  background: rgba(18, 170, 156, 0.58);
}

.thumb-list .thumb-item .cover-tag {
  position: absolute;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, .9);
  color: #fff;
  padding: 5px;
}

.thumb-list .thumb-item .clip-btn,
.thumb-list .thumb-item .del-btn,
.thumb-list .thumb-item .cover-btn,
.thumb-list .thumb-item .res-cover-btn {
  position: absolute;
  cursor: pointer;
  visibility: hidden;
  background: rgba(0, 0, 0, .9);
  color: #fff;
  z-index: 11;
  top: 10px;
  right: 10px;
  padding: 5px;
  border-bottom-left-radius: 3px;
}

.thumb-list .thumb-item .clip-btn {
  top: 38px;
}

.thumb-list .thumb-item .cover-btn {
  top: 66px;
}

.thumb-list .thumb-item .res-cover-btn {
  top: 94px;
}

.thumb-list .thumb-item:hover .oprate-btn {
  visibility: visible;
}

.thumb-list .thumb-item .thumb-img {
  width: 100%;
  background-color: #fff;
}
</style>
